























































import { Component, Prop, Watch, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import AppDialog from '@/components/AppDialog.vue'
import FoldingCard from '@/components/FoldingCard.vue'
import AppSystemInfoCard from '@/components/AppSystemInfoCard.vue'
import { RecordType, RecordTypeAdditionalInfo, RecordTypeFormItem } from '@/modules/RecordType/interfaces/record-type'
import { Account } from '@/modules/Account/interfaces/account'
import AccountDialog from '@/modules/Account/scripts/account-dialog'
import { formatPhoneNumber } from '@/utils/phoneNumberFormat'
import { dateToDisplay } from '@/utils/dateTime'
import { salutation } from '@/modules/Contact/helpers/contact'

@Component({
  components: {
    FoldingCard,
    AppDialog,
    AppSystemInfoCard
  }
})
export default class AccountDetailDetail extends mixins(AccountDialog) {
  @Prop({ type: Object as () => Account }) readonly account!: Account
  @Prop({ type: Object as () => RecordType }) readonly recordType!: RecordType

  salutation = salutation

  contactInfoCard = [
    { title: 'Phone', content: '-' },
    { title: 'Other Phone', content: '-' },
    { title: 'Billing Address Street', content: '-' },
    { title: 'Mailing Address Street', content: '-' },
    { title: 'Billing Address City', content: '-' },
    { title: 'Mailing Address City', content: '-' },
    { title: 'Billing Address State', content: '-' },
    { title: 'Mailing Address State', content: '-' },
    { title: 'Billing Address Zip/Postal Code', content: '-' },
    { title: 'Mailing Address Zip/Postal Code', content: '-' },
    { title: 'Billing Address Country', content: '-' },
    { title: 'Mailing Address Country', content: '-' }
  ]

  sourceInfoCard = [
    { title: 'Source Type', content: '-' },
    { title: 'Sub Source', content: '-', emphasize: true },
    { title: 'Source', content: '-', emphasize: true }
  ]

  additionalInfoCards: {
    title: string;
    items: {[key: string]: string;}[]
  }[] = []

  dateToDisplay = dateToDisplay

  get notes () {
    if (!this.account) return []
    return this.account.notes.split('\n')
  }

  get legalName () {
    return (this.salutation[this.account.salutation] || '-') + ' ' + (this.account.firstName || '-') + ' ' +
    (this.account.middleName || '-') + ' ' + (this.account.lastName || '-')
  }

  @Watch('account', { deep: true })
  onAccountUpdated (val: Account) {
    if (!val) {
      return
    }
    this.contactInfoCard[0].content = val.phone ? formatPhoneNumber(val.phone, val.countryCode, val.extensionNumber) : '-'
    this.contactInfoCard[1].content = val.otherPhone ? formatPhoneNumber(val.otherPhone, val.otherCountryCode, val.otherExtensionNumber) : '-'
    this.contactInfoCard[2].content = val.billingAddressStreet || '-'
    this.contactInfoCard[3].content = val.mailingAddressStreet || '-'
    this.contactInfoCard[4].content = val.billingAddressCity || '-'
    this.contactInfoCard[5].content = val.mailingAddressCity || '-'
    this.contactInfoCard[6].content = val.billingAddressState || '-'
    this.contactInfoCard[7].content = val.mailingAddressState || '-'
    this.contactInfoCard[8].content = val.billingAddressPostalCode || '-'
    this.contactInfoCard[9].content = val.mailingAddressPostalCode || '-'
    this.contactInfoCard[10].content = val.billingAddressCountry || '-'
    this.contactInfoCard[11].content = val.mailingAddressCountry || '-'
    this.udpateAddtionalInfo(val.additionalInfoStr)
  }

  mounted () {
    this.onAccountUpdated(this.account)
  }

  udpateAddtionalInfo (val: string) {
    if (!val) {
      return
    }
    const additionalInfo = JSON.parse(val)
    if (!this.recordType) {
      return
    }
    const recordTypeAddionalInfo = this.recordType.additionalInfo
    this.additionalInfoCards = []

    recordTypeAddionalInfo.map((info: RecordTypeAdditionalInfo) => {
      const { items, title } = info
      if (items) {
        const _items = items.map((item: RecordTypeFormItem) => {
          return {
            title: item.name,
            content: additionalInfo[item.keyName] || '-'
          }
        })
        this.additionalInfoCards.push({
          title: title,
          items: _items
        })
      }
    })
  }

  routeToAccountDetail () {
    if (this.account.parentAccount) {
      this.$router.push({
        name: 'AccountDetailDetail',
        params: {
          id: this.account.parentAccount.id + ''
        }
      })
    }
  }
}
